import React, { Component } from "react";
import { connect } from "react-redux";
import OrderList from "./Order/OrderList";
import { AiFillExclamationCircle, AiFillCheckCircle } from 'react-icons/ai';
import { FaEllo } from 'react-icons/fa';
import {
    Grid,
    Row,
    Col,
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";    
import newOrder from '../../assets/img/newOrder.png';
import inProgress from '../../assets/img/inProgress.png';
import shipped from '../../assets/img/shipped.png';
import { createOrderActions } from "../../redux/actions/create-order-actions";
import { Link } from 'react-router-dom';
import { dataSyncActions } from "../../redux/actions/data-sync-actions";

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: JSON.parse(localStorage.getItem("user")).result.user,
            orderStates: {
                new_orders: '',
                in_progress_orders: '',
                shipped_last_week: '',
            },
            brandErrorState: [
                {
                    "brand_name": '',
                    "total_times_synced": '',
                    "successful_syncs": '',
                    "processing": '',
                    "synced_with_errors": '',
                    "last_sync_status": '',
                    "last_sync_time": ''
                },
            ],
            model_id: '',
        };
    }

    async componentDidMount() {
        try {
            if (this.state.user !== undefined) {
                if (this.state.user.roles[0].name === 'brand manager') {
                    this.setState({
                        model_id: this.state.user.model_id
                    }, async () => {
                        this.props.getErrorStatesForBrandCall(this.state.model_id);
                        const res = await this.props.getOrderStatesForBrandCall(this.state.model_id);
                        if (res.status !== true) {
                            throw Error(res.message)
                        }
                        this.setState({
                            orderStates: res.result
                        })

                    })
                }
            }
        } catch (e) {
            console.log(e)
        }

    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.brandErrorState !== prevProps.brandErrorState && this.props.brandErrorState !== undefined) {
            const { brandErrorState } = this.props;
            this.setState({
                brandErrorState: brandErrorState
            })
        }
    }

    render() {
        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            {
                                <Card
                                    ctTableResponsive
                                    content={
                                        <div>
                                            <Grid fluid>
                                                <Row>
                                                    <Col md={12}>
                                                        <h3 style={{ textAlign: 'left', fontWeight: "500" }}>
                                                            Sales Stats
                                                </h3>
                                                    </Col>

                                                    <Col md={4}>
                                                        <Link to='/Admin/order-list' className="resetLink" style={{ width: '100%' }}>
                                                            <div className="salesStats">
                                                                <div className="statLabel">
                                                                    New Order
                                                    </div>

                                                                <div className="flexElem spaceBetween">
                                                                    <div className="statVal">
                                                                        {this.state.orderStates.new_orders}
                                                                    </div>
                                                                    <div className="statIcon">
                                                                        <img src={newOrder} alt="New orders" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Link to='/Admin/order-list' className="resetLink" style={{ width: '100%' }}>
                                                            <div className="salesStats">
                                                                <div className="statLabel">
                                                                    In Progress
                                                    </div>

                                                                <div className="flexElem spaceBetween">
                                                                    <div className="statVal">
                                                                        {this.state.orderStates.in_progress_orders}
                                                                    </div>
                                                                    <div className="statIcon">
                                                                        <img src={inProgress} alt="New orders" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Link to='/Admin/order-list' className="resetLink" style={{ width: '100%' }}>
                                                            <div className="salesStats">
                                                                <div className="statLabel">
                                                                    Shipped Last Week
                                                    </div>

                                                                <div className="flexElem spaceBetween">
                                                                    <div className="statVal">
                                                                        {this.state.orderStates.shipped_last_week}
                                                                    </div>
                                                                    <div className="statIcon">
                                                                        <img src={shipped} alt="New orders" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </Col>

                                                    <Col md={12}>
                                                        <h3 style={{ textAlign: 'left', fontWeight: "500", marginTop: '40px' }}>
                                                            Sync Status
                                                </h3>
                                                    </Col>

                                                    <Col md={12} className="mb-lg">
                                                        <div className="gridElem grid_4 syncStatusContainer">
                                                            {
                                                                this.state.brandErrorState.map((data, index) => {
                                                                    return (
                                                                        <div key={index}>
                                                                            <div className="flexElem spaceBetween">
                                                                                <div className="syncBrand">
                                                                                    {data.brand_name}
                                                                                </div>
                                                                                <div className="syncStatus">
                                                                                    {
                                                                                        data.last_sync_status === 'processed' ?
                                                                                            <span className="syncSuccess">
                                                                                                <AiFillCheckCircle />
                                                                                            </span>
                                                                                            :
                                                                                            data.last_sync_status === 'processed_with_errors' ?
                                                                                                <span className="syncWarning">
                                                                                                    <AiFillExclamationCircle />
                                                                                                </span> :
                                                                                                <span className="syncProcess">
                                                                                                    <FaEllo className="statusSpinner" />
                                                                                                </span>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                            <div className="flexElem spaceBetween">
                                                                                <div className="syncBrand">
                                                                                    Sync Count:
                                                                            </div>
                                                                                <div className="">
                                                                                    {data.total_times_synced}
                                                                                </div>
                                                                            </div>
                                                                            <div className="flexElem spaceBetween">
                                                                                <div className="syncBrand">
                                                                                    Successful:
                                                                            </div>
                                                                                <div className="">
                                                                                    {data.successful_syncs}
                                                                                </div>
                                                                            </div>
                                                                            <div className="flexElem spaceBetween">
                                                                                <div className="syncBrand">
                                                                                    Processing:
                                                                            </div>
                                                                                <div className="">
                                                                                    {data.processing}
                                                                                </div>
                                                                            </div>
                                                                            <div className="flexElem spaceBetween">
                                                                                <div className="syncBrand">
                                                                                    Failed:
                                                                            </div>
                                                                                <div className="">
                                                                                    {data.synced_with_errors}
                                                                                </div>
                                                                            </div>
                                                                            <div className="flexElem spaceBetween">
                                                                                <div className="syncBrand">
                                                                                    Last Synced:
                                                                            </div>
                                                                                <div className="">
                                                                                    {data.last_sync_time}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Grid>
                                        </div>
                                    } />
                            }
                        </Col>
                    </Row>
                </Grid>
                {
                    this.state.model_id &&
                    <OrderList
                        brandDashboard={true}
                        brandId={this.state.model_id} />
                }
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return ({
        getOrderStatesForBrandCall: (brand_id) => { return dispatch(createOrderActions.getOrderStatesForBrand(brand_id)) },
        getErrorStatesForBrandCall: (id) => { return dispatch(dataSyncActions.getErrorStatesForBrand(id)) },
    });
};

function mapStateToProps(state) {
    const { brandErrorState } = state.dataSyncReducer
    return {
        brandErrorState
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Admin/BrandDashboard.jsx